import React from 'react';
import Icon from '../../mweb/Icon/Icon';
import SectionDivider from '../SectionDivider';
import {
  getProducts,
  resetDayAndProducts,
} from 'hb-redux-store/feature/subscription/subscription.action';
import { connect } from 'react-redux';

const WeekView = props => {
  const { calendar, subscriptionId, getProducts, selectedDay } = props;
  const originalWeeks = calendar?.weeks || [];
  const [weeks, setWeeks] = React.useState(originalWeeks);
  const [days, setDays] = React.useState(calendar?.activeWeek?.days || null);
  const successCb = ({ date }) => {
    const { weeks = [] } = calendar;
    let foundWeek = false,
      updatedDays = null;
    weeks.map(w => {
      const { days = [] } = w;
      const newDays = days.map(d => {
        if (d.date === date) foundWeek = true;
        return { ...d, selected: date === d.date };
      });
      if (foundWeek) {
        updatedDays = newDays;
        foundWeek = false;
      }
    });
    setDays(updatedDays);
  };
  const failCb = err => {};
  const getProductsForDay = day => {
    if (!day.isDayActive || day.date === selectedDay?.date) return;
    getProducts({ subscriptionId, ...day, successCb, failCb });
  };
  return (
    <div>
      <div className="subsc--pane">
        <div className="subsc--pane--title">
          <span className="subsc--pane--title--number">2</span>
          <span>Select Week</span>
        </div>
        <div className="subsc--pane--content">
          <div className="subsc--weeks">
            {weeks?.map(w =>
              w.isWeekActive ? (
                <div
                  className={`subsc--weeks--week ${
                    !w.isWeekActive ? 'inactive' : ''
                  } ${w.selected ? 'selected' : ''}`}
                  key={w.title}
                  onClick={() => {
                    if (!w.isWeekActive || w.selected) return;
                    setWeeks(
                      originalWeeks.map(week => ({
                        ...week,
                        selected: week.title === w.title,
                      }))
                    );
                    setDays(w.days);
                    props.resetDayAndProducts();
                  }}
                >
                  <div className="subsc--weeks--week--title">
                    {w.hasItems && (
                      <Icon class="icon-subscription-tick" size={22} />
                    )}
                    {w.title}
                  </div>
                  <div className="subsc--weeks--week--subtitle">{w.range}</div>
                </div>
              ) : (
                false
              )
            )}
          </div>
        </div>
      </div>
      <SectionDivider />
      {days?.length > 0 && (
        <div className="subsc--pane">
          <div className="subsc--pane--title">
            <span className="subsc--pane--title--number">3</span>
            <span>Select Day</span>
          </div>
          <div className="subsc--pane--content">
            <div className="subsc--days">
              {days?.map(d => (
                <div
                  className={`subsc--days--day ${
                    false === d.isDayActive ? 'inactive' : ''
                  } ${d.date === selectedDay?.date ? 'selected' : ''}`}
                  key={d.date}
                  onClick={() => getProductsForDay(d)}
                >
                  <div className="subsc--days--day--title">
                    {d.hasItems && (
                      <Icon class="icon-subscription-tick" size={22} />
                    )}
                    {d.day}
                  </div>
                  <div className="subsc--days--day--subtitle">
                    {d.formatedDate}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      <SectionDivider />
    </div>
  );
};

const mapStatetoProps = ({ subscriptionReducer }) => ({
  calendar: subscriptionReducer.calendar,
  subscriptionId: subscriptionReducer.subscriptionId,
  selectedDay: subscriptionReducer.selectedDay,
  loading: subscriptionReducer.loading,
});

const mapDispatchToProps = {
  getProducts,
  resetDayAndProducts,
};

export default connect(mapStatetoProps, mapDispatchToProps)(WeekView);
